import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view';


// 弹出框的时候滚动条隐藏和出现导致页面抖动问题
// ElementUI.Dialog.props.lockScroll.default = false;




Vue.use(dataV);
Vue.use(ElementUI);

// 按需引入vue-awesome图标
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';

// 全局注册图标
Vue.component('icon', Icon);


import {Input} from 'element-ui';
Vue.use(Input);
// 适配flex
import '@/common/flexible.js';

// 引入全局css
import './assets/scss/style.scss';


// // swiper bundle styles
// import 'swiper/css/bundle'

// // swiper core styles
// import 'swiper/css'

// // modules styles
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
